module.exports = __webpack_public_path__ + "img/Raw_material_processing_stock.ed57114b.svg";